/**
 * Utility functions for personal message validation and handling
 */

/**
 * Checks if an order has a valid personal message ID
 * @param {Object} order - Order object that may contain pmId
 * @returns {boolean} - True if pmId exists and is a non-empty string
 */
export const hasValidPersonalMessage = (order) => {
  const pmId = order?.pmId;
  return typeof pmId === 'string' && pmId.trim() !== '';
};
